
    $.fn.lightzoom=function(a){a=$.extend({zoomPower:3,glassSize:175},a);var l=a.glassSize/2,m=a.glassSize/4,n=a.zoomPower;$("body").append('<div id="glass"></div>');$("html > head").append($("<style> #glass{width: "+a.glassSize+"px; height: "+a.glassSize+"px;}</style>"));var k;$("#glass").mousemove(function(a){var c=this.targ;a.target=c;k(a,c)});this.mousemove(function(a){k(a,this)});k=function(a,c){document.getElementById("glass").targ=c;var d=a.pageX,e=a.pageY,g=c.offsetWidth,h=c.offsetHeight,b=$(c).offset(),
    f=b.left,b=b.top;d>f&&d<f+g&&b<e&&b+h>e?(offsetXfixer=(d-f-g/2)/(g/2)*m,offsetYfixer=(e-b-h/2)/(h/2)*m,f=(d-f+offsetXfixer)/g*100,b=(e-b+offsetYfixer)/h*100,e-=l,d-=l,$("#glass").css({top:e,left:d,"background-image":" url('"+c.src+"')","background-size":g*n+"px "+h*n+"px","background-position":f+"% "+b+"%",display:"inline-block"}),$("body").css("cursor","none")):($("#glass").css("display","none"),$("body").css("cursor","default"))};return this};
          $(document).ready(function () {
              $('img.light-zoom').lightzoom({
                  zoomPower   : 3,    //Default
                  glassSize   : 180,  //Default
              });
          });

          $('.testimonial-row').slick({
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            dots: true,
            arrows: false,
            autoplay: true,
            responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        }
      ]
          });

         // $('.guarantee-row .guarantee-icons-wrap').slick({
         //    infinite: true,
         //    slidesToShow: 5,
         //    slidesToScroll: 1,
         //    dots: false,
         //    arrows: false,
         //    autoplay: true,
         //    responsive: [
         //       {
         //          breakpoint: 989,
         //          settings: {
         //             slidesToShow: 4,
         //             slidesToScroll: 1,
         //             arrows: true
         //          }
         //       },
         //      {
         //          breakpoint: 767,
         //          settings: {
         //             slidesToShow: 3,
         //             slidesToScroll: 1,
         //             arrows: true
         //          }
         //       }
         //    ]
         // });
    
             $('.main-product-slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            fade: true,
            infinite: true,
            asNavFor: '.thumb-slider'
            });

            $('.thumb-slider').slick({
              slidesToShow: 4,
              slidesToScroll: 1,
              vertical:true,
              verticalSwiping:true,
              asNavFor: '.main-product-slider',
              dots: false,
              infinite: false,
              arrows: false,
              centerMode: false,
              focusOnSelect: true,
              responsive: [
              {
                  breakpoint: 992,
                  settings: {
                    vertical: false,
                    verticalSwiping:false,
                    slidesToShow: 4,
                  }
              }
              ]
            });

      //       $(function() {
      // // Card's slider
      //   var $carousel = $('.main-product-slider');

      //   $carousel
      //     .slick({
      //       slidesToShow: 1,
      //       slidesToScroll: 1,
      //       arrows: true,
      //       fade: true,
      //       infinite: true,
      //       asNavFor: '.thumb-slider'
      //     })
      //     .magnificPopup({
      //       type: 'image',
      //       delegate: 'a:not(.slick-cloned)',
      //       closeOnContentClick: false,
      //       tLoading: 'Загрузка...',
      //       mainClass: 'mfp-zoom-in mfp-img-mobile',
      //       image: {
      //         verticalFit: true,
      //         tError: '<a href="%url%">Фото #%curr%</a> не загрузилось.'
      //       },
      //       gallery: {
      //         enabled: true,
      //         navigateByImgClick: true,
      //         tCounter: '<span class="mfp-counter">%curr% из %total%</span>', // markup of counte
      //         preload: [0,1] // Will preload 0 - before current, and 1 after the current image
      //       },
      //       zoom: {
      //         enabled: true,
      //         duration: 300
      //       },
      //       removalDelay: 300, //delay removal by X to allow out-animation
      //       callbacks: {
      //         open: function() {
      //           //overwrite default prev + next function. Add timeout for css3 crossfade animation
      //           $.magnificPopup.instance.next = function() {
      //             var self = this;
      //             self.wrap.removeClass('mfp-image-loaded');
      //             setTimeout(function() { $.magnificPopup.proto.next.call(self); }, 120);
      //           };
      //           $.magnificPopup.instance.prev = function() {
      //             var self = this;
      //             self.wrap.removeClass('mfp-image-loaded');
      //             setTimeout(function() { $.magnificPopup.proto.prev.call(self); }, 120);
      //           };
      //           var current = $carousel.slick('slickCurrentSlide');
      //           $carousel.magnificPopup('goTo', current);
      //         },
      //         imageLoadComplete: function() {
      //           var self = this;
      //           setTimeout(function() { self.wrap.addClass('mfp-image-loaded'); }, 16);
      //         },
      //         beforeClose: function() {
      //           $carousel.slick('slickGoTo', parseInt(this.index));
      //         }
      //       }
      //     });
      //   $('.thumb-slider').slick({
      //       slidesToShow: 4,
      //         slidesToScroll: 1,
      //         vertical:true,
      //         verticalSwiping:true,
      //         asNavFor: '.main-product-slider',
      //         dots: false,
      //         infinite: false,
      //         arrows: false,
      //         centerMode: false,
      //         focusOnSelect: true,
      //         responsive: [
      //         {
      //         breakpoint: 992,
      //         settings: {
      //           vertical: false,
      //           verticalSwiping:false,
      //           slidesToShow: 4,
      //         }
      //       }
      //       ]
      //   });
      // });